module.exports = __webpack_public_path__ + "static/media/totalPnts_5000_7500.91d321cc.png";